export const n = 21;//row
export const m = 51;//column